// extracted by mini-css-extract-plugin
export default {"InstructionStepsList":"InstructionStepsList_InstructionStepsList__4NWhE"};